"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGridSignalsInitParams = exports.useAppInfo = exports.useSettings = void 0;
var react_1 = require("react");
var is_dev_1 = __importDefault(require("./is-dev"));
var get_local_browser_settings_1 = __importDefault(require("./get-local-browser-settings"));
var DEVELOPMENT_ID = 'XXXXXXXXXXXXXXXXXXXXXXXX';
var log = function () {
    var data = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        data[_i] = arguments[_i];
    }
    if (process.env.NODE_ENV === 'test')
        return;
    console.log.apply(console, data);
};
var getCwd = function () {
    try {
        // This code runs in browser and browser runtime has no variable called "process".
        // It was possible to use it previously because webpack was providing it.
        // Unfortunately webpack version 5 doesn't do it anymore.
        return process.cwd();
    }
    catch (error) {
        return '';
    }
};
var getDevSettings = function (devSettings) {
    log('Settings development mode', getCwd());
    var fetchFsSettings = function () {
        try {
            var settings_1 = require('settings/index.json');
            return settings_1;
        }
        catch (e) {
            console.log('e:', e);
            throw Error("Settings development mode: 'settings/index.json' not found");
        }
    };
    var settings = devSettings ? devSettings : fetchFsSettings();
    return __assign(__assign({}, settings.app.gridApp.settings), { _general: settings.general, _buildInfo: {
            appName: DEVELOPMENT_ID,
            buildId: DEVELOPMENT_ID,
            bootVersion: DEVELOPMENT_ID,
        }, _mobileEndpointInfo: {
            id: DEVELOPMENT_ID,
            urlId: DEVELOPMENT_ID,
            displayName: DEVELOPMENT_ID,
            env: 'DEVELOPMENT',
            installationId: DEVELOPMENT_ID,
            organizationId: DEVELOPMENT_ID,
            space: DEVELOPMENT_ID,
        }, _gridapp: {
            id: DEVELOPMENT_ID,
            buildId: DEVELOPMENT_ID,
            name: DEVELOPMENT_ID,
            iconUrl: DEVELOPMENT_ID,
        } });
};
function useSettings(props) {
    if (props === void 0) { props = {}; }
    var hasLoadedSettings = react_1.useRef(false);
    var _a = react_1.useState(null), settings = _a[0], setSettings = _a[1];
    react_1.useEffect(function () {
        var handler = function () {
            // settings are ready for use!
            var gridapp = window.gridapp;
            if (gridapp && !hasLoadedSettings.current) {
                log('Settings ready', gridapp);
                var gridappSettings = gridapp.getSettings();
                setSettings(gridappSettings);
                hasLoadedSettings.current = true;
            }
        };
        if (is_dev_1.default) {
            setSettings(getDevSettings(props.devSettings));
        }
        else {
            log('Settings production mode');
            try {
                handler();
            }
            catch (err) {
                // no action
            }
            window.addEventListener('GridappReady', handler);
        }
        return function () { return window.removeEventListener('GridappReady', handler); };
    }, []);
    return settings;
}
exports.useSettings = useSettings;
var getHashParams = function () {
    var hashParamsArr = window.location.hash.split('#')[1] || '';
    if (!hashParamsArr)
        return {};
    return hashParamsArr.split('&').reduce(function (acc, item) {
        if (item && item.includes('=')) {
            var param = item.split('=');
            acc[param[0]] = param[1];
        }
        return acc;
    }, {});
};
var getDeviceInfo = function () {
    // Note: Do not immediately return null if NODE_ENV is dev
    // Sometimes we render the app within same network on GridOS device for development
    var data = /GridOS\/[0-9.]+ \((.+)\)/.exec(navigator.userAgent);
    var userAgentDeviceInfo = {};
    // cog-based screen module
    if (data && data[1]) {
        userAgentDeviceInfo = data[1]
            .split('; ')
            .map(function (line) { return line.split('='); })
            .reduce(function (res, _a) {
            var _b;
            var name = _a[0], val = _a[1];
            return (__assign(__assign({}, res), (_b = {}, _b[name] = val, _b)));
        }, {});
    }
    // electron-based screen module
    var hashParams = getHashParams();
    if (Object.keys(hashParams).length || Object.keys(userAgentDeviceInfo).length) {
        var deviceInfo = __assign(__assign(__assign({}, userAgentDeviceInfo), hashParams), { id: hashParams.browserId, name: hashParams.deviceName, accessId: hashParams.browserId, accessToken: hashParams.accessKey });
        return deviceInfo;
    }
    if (is_dev_1.default)
        return null;
    var browserSettings = get_local_browser_settings_1.default();
    console.log('browserSettings:', JSON.stringify(browserSettings));
    if (!browserSettings)
        return null;
    return {
        id: browserSettings.uuid,
        name: browserSettings.displayName,
        env: browserSettings.env,
        accessId: browserSettings.uuid,
        accessToken: browserSettings.accessKey,
        spaceId: browserSettings.spaces && browserSettings.spaces.length
            ? browserSettings.spaces[0]
            : '',
    };
};
exports.useAppInfo = function (props) {
    if (props === void 0) { props = {}; }
    var _a = react_1.useState(null), appInfo = _a[0], setAppInfo = _a[1];
    var settings = useSettings(props);
    react_1.useEffect(function () {
        if (is_dev_1.default) {
            setAppInfo(getDevSettings(props.devSettings)._general);
        }
        else if (settings && settings._general) {
            var device = getDeviceInfo();
            var mobileEndpointInfo = settings._mobileEndpointInfo;
            console.log('useAppInfo-debug_mobileEndpointInfo:', mobileEndpointInfo);
            var isMobileEndpoint = Object.keys(mobileEndpointInfo || {}).length > 0;
            if (device) {
                delete device.accessId;
                delete device.accessToken;
            }
            setAppInfo(__assign(__assign(__assign({}, settings._general), { device: device }), (isMobileEndpoint ? { mobileEndpoint: mobileEndpointInfo } : {})));
        }
    }, [settings]);
    return appInfo;
};
exports.useGridSignalsInitParams = function (props) {
    if (props === void 0) { props = {}; }
    var _a = react_1.useState(null), params = _a[0], setParams = _a[1];
    var settings = useSettings(props);
    react_1.useEffect(function () {
        var _a, _b, _c, _d;
        if (settings && settings._general && settings._gridapp) {
            var device = getDeviceInfo();
            var mobileEndpointInfo = settings._mobileEndpointInfo;
            console.log('useGridSignalsInitParams-debug_mobileEndpointInfo:', mobileEndpointInfo);
            var isMobileEndpoint = Object.keys(mobileEndpointInfo || {}).length > 0;
            var environment = '';
            var spaceId = '';
            if (is_dev_1.default) {
                environment = 'DEVELOPMENT';
                spaceId = DEVELOPMENT_ID;
            }
            else if (isMobileEndpoint) {
                environment = mobileEndpointInfo.env;
                spaceId = mobileEndpointInfo.space;
            }
            else {
                environment = device === null || device === void 0 ? void 0 : device.env;
                spaceId = device === null || device === void 0 ? void 0 : device.spaceId;
            }
            setParams({
                tenantId: settings._general.organizationId,
                environment: (environment || '').toUpperCase(),
                dataResidency: settings._general.dataResidency,
                country: settings._general.country,
                // TODO: Add support with env later. this is supported in the analytics service out-of-the-box
                // locationAccuracy: 10,
                // latitude: 0,
                // longitude: 0,
                spaceId: spaceId || '',
                appId: is_dev_1.default ? DEVELOPMENT_ID : ((_a = settings._gridapp) === null || _a === void 0 ? void 0 : _a.id) || '',
                appVersion: is_dev_1.default ? DEVELOPMENT_ID : ((_b = settings._gridapp) === null || _b === void 0 ? void 0 : _b.buildId) || '',
                installationId: ((_c = settings._general) === null || _c === void 0 ? void 0 : _c.appId) || '',
                installationVersion: is_dev_1.default ? DEVELOPMENT_ID : ((_d = settings._buildInfo) === null || _d === void 0 ? void 0 : _d.buildId) || '',
                // mobile will not have deviceId but clientId will be auto-generated by grid-signals library
                deviceId: is_dev_1.default ? undefined : device === null || device === void 0 ? void 0 : device.id,
                accessId: is_dev_1.default ? undefined : device === null || device === void 0 ? void 0 : device.accessId,
                accessToken: is_dev_1.default ? undefined : device === null || device === void 0 ? void 0 : device.accessToken,
            });
        }
    }, [settings]);
    return params;
};
exports.default = { useSettings: useSettings, useAppInfo: exports.useAppInfo, useGridSignalsInitParams: exports.useGridSignalsInitParams };
